import { PropsWithChildren } from 'react';

import { cn } from '@components/primitives/utilities';

import css from './styles.module.css';

/**
 * An empty state sits inside a section that already has its own heading, so it
 * never renders an `h1`.
 */
type HeadingLevel = 'h2' | 'h3' | 'h4' | 'h5' | 'h6';

export interface EmptyStateTitleProps extends PropsWithChildren {
  /** The heading level to render at. Defaults to an `h3`. */
  as?: HeadingLevel;
  /** Applied to the heading, alongside the pattern's own classes. */
  className?: string;
}

/** The heading naming what is missing. */
export function EmptyStateTitle({
  as: Component = 'h3',
  className,
  children,
}: EmptyStateTitleProps) {
  return <Component className={cn(css.title, className)}>{children}</Component>;
}
